"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _stringInput = _interopRequireDefault(require("../string-input"));
var _numberInput = _interopRequireDefault(require("../number-input"));
var _dateInput = _interopRequireDefault(require("../date-input"));
var _timeInput = _interopRequireDefault(require("../time-input"));
var _simpleSelectionInput = _interopRequireDefault(require("../simple-selection-input"));
var _fileInput = _interopRequireDefault(require("../file-input"));
var _imageInput = _interopRequireDefault(require("../image-input"));
var _selectInput = _interopRequireDefault(require("../select-input"));
var _textInput = _interopRequireDefault(require("../text-input"));
var _percentageInput = _interopRequireDefault(require("../percentage-input"));
var _multipleSelectInput = _interopRequireDefault(require("../multiple-select-input"));
require("./styles.css");
var _fieldTypes = require("../../constants/field-types");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function StandardFormContainer(props) {
  var _useState = (0, _react.useState)({}),
    _useState2 = _slicedToArray(_useState, 2),
    form = _useState2[0],
    setForm = _useState2[1];
  var _useState3 = (0, _react.useState)(),
    _useState4 = _slicedToArray(_useState3, 2),
    patch = _useState4[0],
    setPatch = _useState4[1];
  var _useState5 = (0, _react.useState)(),
    _useState6 = _slicedToArray(_useState5, 2),
    prePatch = _useState6[0],
    setPrePatch = _useState6[1];
  var _useState7 = (0, _react.useState)({}),
    _useState8 = _slicedToArray(_useState7, 2),
    confirmation = _useState8[0],
    setConfirmation = _useState8[1];
  var _props = _objectSpread({}, props),
    fields = _props.fields,
    errors = _props.errors,
    onChange = _props.onChange,
    onPatchChange = _props.onPatchChange,
    onPrePatchChange = _props.onPrePatchChange,
    initialForm = _props.initialForm,
    onBlur = _props.onBlur,
    biRef = _props.biRef,
    editable = _props.editable,
    isFilter = _props.isFilter,
    containerClass = _props.containerClass;
  (0, _react.useEffect)(function () {
    if (onChange) {
      onChange(form);
    }
  }, [form]);
  (0, _react.useEffect)(function () {
    if (onPatchChange) {
      onPatchChange(patch);
    }
  }, [patch]);
  (0, _react.useEffect)(function () {
    if (onPrePatchChange) {
      onPrePatchChange(prePatch);
    }
  }, [prePatch]);
  (0, _react.useEffect)(function () {
    if (initialForm != null) setForm(initialForm);
  }, [initialForm]);
  function updateForm(field, value) {
    setForm(function (form) {
      return _objectSpread(_objectSpread({}, form), {}, _defineProperty({}, field, value));
    });
    setPrePatch(_defineProperty({}, field, value));
  }
  function cleanForm() {
    setForm({});
  }
  function customOnBlur() {
    setPatch(prePatch);
    if (onBlur) onBlur(prePatch);
  }
  function handleOnDateBlur(field, value) {
    setPatch(_defineProperty({}, field, value));
    if (onBlur) onBlur(prePatch);
  }
  if (biRef) {
    biRef.updateForm = updateForm;
    biRef.cleanForm = cleanForm;
  }
  function switchField(field, index, showTitle) {
    if (field.readOnly && !form[field.name] && typeof form[field.name] != "boolean") return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
    switch (field.type) {
      case _fieldTypes.STRING:
        return /*#__PURE__*/_react.default.createElement(_stringInput.default, {
          showTitle: showTitle,
          key: index,
          onBlur: customOnBlur,
          label: field.label,
          value: form[field.name] || "",
          inputMask: field.mask,
          placeHolder: field.placeHolder,
          onChange: function onChange(text) {
            return updateForm(field.name, text);
          },
          editable: (field.editable || editable) && !field.readOnly,
          error: errors[field.name],
          containerClass: field.containerClass,
          inputClass: field.inputClass,
          maxLength: field.maxLength,
          mandatory: isFilter ? field.mandatoryAsFilter : field.mandatory
        });
      case _fieldTypes.PERCENTAGE:
        return /*#__PURE__*/_react.default.createElement(_percentageInput.default, {
          showTitle: showTitle,
          key: index,
          onBlur: customOnBlur,
          label: field.label,
          value: form[field.name] || "",
          placeHolder: field.placeHolder,
          onChange: function onChange(text) {
            return updateForm(field.name, text);
          },
          editable: (field.editable || editable) && !field.readOnly,
          error: errors[field.name],
          containerClass: field.containerClass,
          inputClass: field.inputClass,
          mandatory: isFilter ? field.mandatoryAsFilter : field.mandatory
        });
      case _fieldTypes.INTEGER:
      case _fieldTypes.FLOAT:
        return /*#__PURE__*/_react.default.createElement(_numberInput.default, {
          showTitle: showTitle,
          key: index,
          onBlur: customOnBlur,
          label: field.label,
          value: form[field.name] || "",
          inputMask: "9*",
          placeHolder: field.placeHolder,
          onChange: function onChange(text) {
            updateForm(field.name, field.type === _fieldTypes.INTEGER ? parseInt(text) : parseFloat(text));
          },
          editable: (field.editable || editable) && !field.readOnly,
          error: errors[field.name],
          containerClass: field.containerClass,
          inputClass: field.inputClass,
          mandatory: isFilter ? field.mandatoryAsFilter : field.mandatory
        });
      case _fieldTypes.TEXT:
        return /*#__PURE__*/_react.default.createElement(_textInput.default, {
          showTitle: showTitle,
          key: index,
          label: field.label,
          onBlur: customOnBlur,
          value: form[field.name] || "",
          onChange: /*#__PURE__*/function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(date) {
              return _regeneratorRuntime().wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return updateForm(field.name, date);
                  case 2:
                    onBlur();
                  case 3:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            }));
            return function (_x) {
              return _ref.apply(this, arguments);
            };
          }(),
          editable: (field.editable || editable) && !field.readOnly,
          error: errors[field.name],
          containerClass: field.containerClass,
          inputClass: field.inputClass,
          maxLength: field.maxLength,
          mandatory: isFilter ? field.mandatoryAsFilter : field.mandatory
        });
      case _fieldTypes.DATE:
        return /*#__PURE__*/_react.default.createElement(_dateInput.default, {
          showTitle: showTitle,
          key: index,
          label: field.label,
          value: form[field.name],
          onChange: function onChange(date) {
            updateForm(field.name, date);
            handleOnDateBlur(field.name, date);
          },
          peekNextMonth: true,
          showMonthDropdown: true,
          showYearDropdown: true,
          editable: (field.editable || editable) && !field.readOnly,
          error: errors[field.name],
          containerClass: field.containerClass,
          inputClass: field.inputClass,
          mandatory: isFilter ? field.mandatoryAsFilter : field.mandatory
        });
      case _fieldTypes.DATE_TIME:
        return /*#__PURE__*/_react.default.createElement(_dateInput.default, {
          isDateTime: true,
          showTitle: showTitle,
          key: index,
          label: field.label,
          value: form[field.name],
          onChange: function onChange(date) {
            updateForm(field.name, date);
            handleOnDateBlur(field.name, date);
          },
          peekNextMonth: true,
          showMonthDropdown: true,
          showYearDropdown: true,
          editable: (field.editable || editable) && !field.readOnly,
          error: errors[field.name],
          containerClass: field.containerClass,
          inputClass: field.inputClass,
          mandatory: isFilter ? field.mandatoryAsFilter : field.mandatory
        });
      case _fieldTypes.TIME:
        return /*#__PURE__*/_react.default.createElement(_timeInput.default, {
          showTitle: showTitle,
          key: index,
          label: field.label,
          value: form[field.name],
          onBlur: customOnBlur,
          onChange: function onChange(time) {
            return updateForm(field.name, time);
          },
          editable: (field.editable || editable) && !field.readOnly,
          error: errors[field.name],
          containerClass: field.containerClass,
          inputClass: field.inputClass,
          mandatory: isFilter ? field.mandatoryAsFilter : field.mandatory
        });
      case _fieldTypes.SIMPLE_SELECTION:
        if (!isFilter && typeof form[field.name] != "boolean" && !form[field.name] && field.itens.length > 0) updateForm(field.name, field.itens[0].value);
        return /*#__PURE__*/_react.default.createElement(_simpleSelectionInput.default, {
          showTitle: showTitle,
          key: index,
          itens: field.itens,
          label: field.label,
          selected: form[field.name] !== undefined ? form[field.name] : "",
          onBlur: customOnBlur,
          onChange: function onChange(value) {
            return updateForm(field.name, value);
          },
          editable: (field.editable || editable) && !field.readOnly,
          error: errors[field.name],
          containerClass: field.containerClass,
          inputClass: field.inputClass,
          isFilter: isFilter,
          mandatory: isFilter ? field.mandatoryAsFilter : field.mandatory
        });
      case _fieldTypes.FILE:
        return /*#__PURE__*/_react.default.createElement(_fileInput.default, {
          showTitle: showTitle,
          key: index,
          label: field.label,
          value: form[field.name],
          onBlur: customOnBlur,
          onChange: function onChange(value) {
            return updateForm(field.base64Field, value);
          },
          editable: (field.editable || editable) && !field.readOnly,
          error: errors[field.name],
          containerClass: field.containerClass,
          inputClass: field.inputClass,
          mandatory: isFilter ? field.mandatoryAsFilter : field.mandatory
        });
      case _fieldTypes.COMPLEX:
        if (!form[field.name]) form[field.name] = {};
        if (biRef) {
          biRef[field.name] = {};
        }
        return /*#__PURE__*/_react.default.createElement(StandardFormContainer, _extends({}, props, {
          biRef: biRef ? biRef[field.name] : null,
          showTitle: showTitle,
          key: index,
          fields: field.fields,
          onPrePatchChange: function onPrePatchChange(prePatch) {
            return setPrePatch(prePatch);
          },
          onChange: function onChange(fieldForm) {
            return setForm(_objectSpread(_objectSpread({}, form), {}, _defineProperty({}, field.name, fieldForm)));
          },
          initialForm: initialForm ? initialForm[field.name] : null,
          editable: (field.editable || editable) && !field.readOnly,
          errors: errors[field.name] || {},
          onBlur: function onBlur(blurPatch) {
            if (blurPatch && patch && blurPatch !== patch[field.name] || blurPatch && !patch) {
              var _patch = _defineProperty({}, field.name, blurPatch);
              setPrePatch(_patch);
              setPatch(_patch);
            }
          }
        }));
      case _fieldTypes.AUTOCOMPLETE:
        return /*#__PURE__*/_react.default.createElement(_selectInput.default, {
          showTitle: showTitle,
          key: index,
          options: field,
          label: field.label,
          onBlur: customOnBlur,
          initialValue: form[field.name],
          onChange: function onChange(value) {
            return updateForm(field.name, value);
          },
          editable: (field.editable || editable) && !field.readOnly,
          error: errors[field.name],
          containerClass: field.containerClass,
          inputClass: field.inputClass,
          mandatory: isFilter ? field.mandatoryAsFilter : field.mandatory
        });
      case _fieldTypes.CUSTOM:
        return props[field.renderName](form);
      case _fieldTypes.MULTIPLE_SELECTION:
        return /*#__PURE__*/_react.default.createElement(_multipleSelectInput.default, {
          showTitle: showTitle,
          index: index,
          initialValue: form[field.name],
          label: field.label,
          list: field.itens,
          labelField: field.labelField,
          valueField: field.valueField,
          loadItemUrl: field.loadItemUrl,
          onBlur: customOnBlur,
          placeholder: field.placeholder,
          onChange: function onChange(value) {
            return updateForm(field.name, value);
          },
          editable: ((field === null || field === void 0 ? void 0 : field.editable) || editable) && !field.readOnly,
          error: errors[field.name],
          hasOther: field.hasOther,
          containerClass: field.containerClass,
          contentClass: field.contentClass,
          containerSelected: field.containerSelected,
          itemSelected: field.itemSelected,
          buttomDrop: field.buttomDrop,
          containerDropdown: field.containerDropdown,
          itemDropdown: field.itemDropdown,
          otherContainer: field.otherContainer,
          btnAdd: field.btnAdd,
          inputOther: field.inputOther,
          autocomplete: field.autocomplete,
          searchUrl: field.searchUrl,
          searchContentField: field.searchContentField,
          mandatory: isFilter ? field.mandatoryAsFilter : field.mandatory
        });
      case _fieldTypes.IMAGE:
        return /*#__PURE__*/_react.default.createElement(_imageInput.default, {
          showTitle: showTitle,
          key: index,
          label: field.label,
          value: form[field.name],
          onBlur: customOnBlur,
          onChange: function onChange(value) {
            return updateForm(field.base64Field, value);
          },
          editable: (field.editable || editable) && !field.readOnly,
          error: errors[field.name],
          containerClass: field.containerClass,
          inputClass: field.inputClass,
          imgClass: field.imgClass,
          mandatory: isFilter ? field.mandatoryAsFilter : field.mandatory
        });
      default:
    }
  }
  function showField(field, index) {
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
      key: index
    }, field.confirmation && /*#__PURE__*/_react.default.createElement(_simpleSelectionInput.default, {
      showTitle: true,
      key: -(index + 1),
      buttons: field.confirmation.options,
      label: field.label,
      selected: confirmation[field.name],
      onChange: function onChange(value) {
        setConfirmation(_objectSpread(_objectSpread({}, confirmation), {}, _defineProperty({}, field.name, value)));
        if (value !== 0) setForm(_objectSpread(_objectSpread({}, form), {}, _defineProperty({}, field.name, null)));
      }
    }), (!field.confirmation || confirmation[field.name] === 0) && switchField(field, index, !field.confirmation));
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "wm-sf-container-container " + containerClass
  }, fields === null || fields === void 0 ? void 0 : fields.map(showField));
}
var _default = exports.default = StandardFormContainer;